<script lang="ts">import CardLinesMobile from "../images/card-lines-mobile.svg";
import CardLines from "../images/card-lines.svg";
import PonyIllustration from "../images/pony-illustration.svg";
import { Button } from "@infinitro/button";
import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isSmallMonitor, isSpecialWidthCase, loggedIn, toSiteUrl } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import "../api/api";
export let race;
export let raceId = undefined;
</script>

<div class="info-card-with-illustrations">
	<Container width="56.25rem">
		{#if !$isMobile && !$isSpecialWidthCase && !isSmallMonitor}
			<div class="pony-illustration-container">
				<img
					src={PonyIllustration}
					alt={$t(Verbiage.illustration_alt, 'alts')}
					class="pony-illustration"
				/>
			</div>
		{/if}
		<InfoCard width="100%">
			{#if $isMobile}
				<div class="card-lines-mobile">
					<img
						src={CardLinesMobile}
						alt={$t(Verbiage.illustration_alt, 'alts')}
						class="left-card-lines-mobile-image"
					/>
					<img
						src={CardLinesMobile}
						alt={$t(Verbiage.illustration_alt, 'alts')}
						class="right-card-lines-mobile-image"
					/>
				</div>
			{:else}
				<div class="card-lines">
					<img
						src={CardLines}
						alt={$t(Verbiage.illustration_alt, 'alts')}
						class="left-card-lines-image"
					/>
					<img
						src={CardLines}
						alt={$t(Verbiage.illustration_alt, 'alts')}
						class="right-card-lines-image"
					/>
				</div>
			{/if}
			<div class="info-text-title">
				<Text
					type="title"
					titleWeight="bold"
					customStyle="{$isMobile
						? 'font-size: 1.5rem !important;'
						: 'font-size: 2rem !important;'} line-height: 2.5rem !important;"
					textAlign="center"
				>
					{$t(Verbiage.info_card_title_part_1)}
				</Text>
				<Text
					type="title"
					titleWeight="bold"
					customStyle="{$isMobile
						? 'font-size: 1.5rem !important;'
						: 'font-size: 2rem !important;'} line-height: 2.5rem !important; color: #FFCE2B !important;"
					textAlign="center"
				>
					{$t(Verbiage.info_card_title_part_2)}
				</Text>
			</div>

			<div class="info-text-description">
				<Text
					type="body"
					textAlign="center"
					customStyle="font-size: 1rem !important; line-height: 1.5rem !important;"
				>
					{$t(Verbiage.info_card_description_1)}
				</Text>

				<Text
					type="body"
					textAlign="center"
					customStyle="font-size: 1rem !important; line-height: 1.5rem !important;"
				>
					{$t(Verbiage.info_card_description_2)}
				</Text>

				<Text
					type="body"
					textAlign="center"
					customStyle="font-size: 1rem !important; line-height: 1.5rem !important;"
				>
					{$t(Verbiage.info_card_description_3)}
				</Text>

				<Text
					type="body"
					textAlign="center"
					customStyle="font-size: 1rem !important; line-height: 1.5rem !important;"
				>
					{$t(Verbiage.info_card_description_4)}
				</Text>
			</div>

			<div class="info-text-description-footer">
				<Text
					type="body"
					bodyWeight="bold"
					customStyle="font-size: 1rem !important; line-height: 1.5rem !important;"
					textAlign="center"
				>
					{$t(Verbiage.info_card_footer_1)}
				</Text>

				<Text
					type="body"
					bodyWeight="bold"
					customStyle="font-size: 1rem !important; line-height: 1.5rem !important;"
					textAlign="center"
				>
					{$t(Verbiage.info_card_footer_2)}
				</Text>
			</div>

			<div class="info-card-button-container">
				<a href={toSiteUrl('/casino', $loggedIn)}>
					<Button>
						<Text type="body" bodyWeight="black" bodySize="large">
							{$t(Verbiage.play_now)}
						</Text>
					</Button>
				</a>
			</div>
		</InfoCard>
	</Container>
</div>

<style>
	.left-card-lines-image,
	.left-card-lines-mobile-image {

		position: absolute;

		left: 0px;

		top: 0px
}

	.right-card-lines-image,
	.right-card-lines-mobile-image {

		position: absolute;

		right: 0px;

		top: 0px;

		--tw-scale-x: -1;

		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

	.info-text-description {

		margin-left: auto;

		margin-right: auto;

		margin-top: 0.625rem;

		width: 100%
}

	.info-text-description-footer {

		margin-left: auto;

		margin-right: auto;

		margin-top: 0.625rem;

		width: 100%
}

	.info-card-button-container {

		margin-left: auto;

		margin-right: auto;

		margin-top: 0.625rem;

		display: flex;

		width: 100%;

		align-items: center;

		justify-content: center
}

	.pony-illustration {

		position: absolute;

		top: -4.053rem;

		left: -15.625rem
}

	@media (min-width: 1024px) {
		.info-text-description,
		.info-text-description-footer,
		.info-card-button-container {

				margin-top: 2rem
		}
	}

	@media (min-width: 430px) {
		.info-text-description,
		.info-text-description-footer,
		.info-card-button-container {

				margin-top: 2rem
		}
	}
</style>
